const l = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let r = (t = 21) => {
  let e = "", n = crypto.getRandomValues(new Uint8Array(t));
  for (; t--; )
    e += l[n[t] & 63];
  return e;
};
export {
  r as n
};
